<template>
  <a-layout>
    <a-layout-content>
      <div :class="$style.pageWrapper">
        <div :class="$style.logoContainer">
          <div :class="$style.logo">
            <img src="taxi-logo.png" style="max-width:100%;height:auto;" alt="Taxi Contigo" />
          </div>
        </div>
        <div :class="$style.containerInner">
          <transition :name="settings.routerAnimation" mode="out-in">
            <router-view />
          </transition>
          <br>
          <div class="text-center">
            Copyright © {{new Date().getFullYear()}} Taxi
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AuthLayout',
  computed: mapState(['settings']),
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
